import {combineReducers} from 'redux';
import {reducer as listReducer} from './mission_list';
import {reducer as mission_detail} from './mission_detail';
import {reducer as error_duty} from './error_duty';

const reducer = combineReducers({
    missionList: listReducer,
    missionDetail:mission_detail,
    errorDuty:error_duty,
});

export default reducer


// WEBPACK FOOTER //
// ./src/entry_app/question_box/reducer.js